/* ShopYourHandle catalogue - client render + filtering, ported 1:1 from
   lib/filters.ts + components/catalog-view.tsx. Data from assets/catalog.json. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ni-catalog]');
  if (!root) return;
  var PAGE_SIZE = 60;
  var RANK = { legendary: 0, rare: 1, uncommon: 2, common: 3 };

  var PLAT_SVG = {
    instagram: '<svg viewBox="0 0 24 24" fill="none"><rect x="6" y="6" width="12" height="12" rx="4" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="17" cy="7" r="1.1" fill="currentColor"/></svg>',
    tiktok: '<svg viewBox="0 0 24 24"><path d="M15.2 6.2c.4 1.3 1.4 2.3 2.7 2.6v2.1c-1-.02-1.9-.3-2.7-.8v3.9a3.9 3.9 0 1 1-3.9-3.9c.2 0 .3 0 .5.02v2.1a1.85 1.85 0 1 0 1.3 1.77V6.2h2.1z" fill="currentColor"/></svg>',
    telegram: '<svg viewBox="0 0 24 24"><path d="M6 11.8l10.2-3.94c.47-.17.88.11.73.83l-1.74 8.2c-.12.56-.46.7-.93.44l-2.56-1.89-1.24 1.19c-.14.14-.25.25-.5.25l.18-2.6 4.73-4.27c.2-.18-.05-.28-.32-.1L7.6 12.6l-2.52-.79c-.55-.17-.56-.55.12-.81z" fill="currentColor"/></svg>',
    twitter: '<svg viewBox="0 0 24 24"><path d="M6.6 6h3.4l3 4.1L16.6 6h1.9l-4.6 5.3L19 18h-3.4l-3.2-4.4L8.6 18H6.7l4.9-5.7L6.6 6zm1.9 1.2l7 9.6h1.2l-7-9.6H8.5z" fill="currentColor"/></svg>',
    discord: '<svg viewBox="0 0 24 24"><path d="M16.4 7.3a10.5 10.5 0 0 0-2.6-.8l-.12.25a9.7 9.7 0 0 1 2.36.9 8 8 0 0 0-8.08 0 9.7 9.7 0 0 1 2.36-.9L10.2 6.5a10.5 10.5 0 0 0-2.6.8C6.06 9.6 5.64 11.83 5.85 14a10.6 10.6 0 0 0 3.2 1.6l.66-1.06a6.5 6.5 0 0 1-1.04-.5l.26-.2a7.5 7.5 0 0 0 6.14 0l.26.2c-.33.2-.68.37-1.04.5l.66 1.06a10.6 10.6 0 0 0 3.2-1.6c.25-2.5-.42-4.68-1.75-6.7zM9.9 12.7c-.62 0-1.13-.57-1.13-1.27s.5-1.27 1.13-1.27c.63 0 1.14.57 1.13 1.27 0 .7-.5 1.27-1.13 1.27zm4.2 0c-.62 0-1.13-.57-1.13-1.27s.5-1.27 1.13-1.27c.63 0 1.14.57 1.13 1.27 0 .7-.5 1.27-1.13 1.27z" fill="currentColor"/></svg>',
    snapchat: '<svg viewBox="0 0 24 24"><path d="M12 5.4c1.9 0 3.1 1.5 3.15 3.3.02.5-.03 1 .02 1.3.1.2.5.2.8.1.35-.1.6.1.6.35 0 .3-.45.45-.8.6-.28.12-.5.25-.45.55.15.9 1.2 1.65 2 1.85.25.06.35.25.28.45-.15.42-1.05.6-1.4.66-.1.02-.16.14-.18.28-.02.14-.05.34-.3.34-.4 0-.9-.28-1.65-.06-.6.18-1.15.9-2.34.9s-1.7-.72-2.34-.9c-.75-.22-1.25.06-1.65.06-.25 0-.28-.2-.3-.34-.02-.14-.08-.26-.18-.28-.35-.06-1.25-.24-1.4-.66-.07-.2.03-.39.28-.45.8-.2 1.85-.95 2-1.85.05-.3-.17-.43-.45-.55-.35-.15-.8-.3-.8-.6 0-.25.25-.45.6-.35.3.1.7.1.8-.1.05-.3 0-.8.02-1.3C8.9 6.9 10.1 5.4 12 5.4z" fill="currentColor"/></svg>',
  };

  /* ---- filter helpers (lib/filters.ts) ---- */
  function lengthOption(name) { return name.length >= 7 ? '7+' : String(Math.max(2, name.length)); }
  function nameComposition(name) {
    if (/[._]/.test(name)) return 'special';
    if (/^[a-z]+$/i.test(name)) return 'letters';
    if (/^[0-9]+$/.test(name)) return 'digits';
    return 'mix';
  }
  function matchesPattern(name, pattern) {
    if (pattern === 'all') return true;
    var n = name.toLowerCase();
    if (pattern === 'double') return /(.)\1/.test(n);
    if (pattern === 'repeating') return /^(.+?)\1+$/.test(n);
    return n.length >= 2 && n === n.split('').reverse().join('');
  }
  function filterHandles(all, f) {
    var q = f.query.trim().toLowerCase();
    var prefix = f.startsWith.trim().toLowerCase();
    var out = all.filter(function (h) {
      if (q && h.n.toLowerCase().indexOf(q) === -1 && !h.tags.some(function (t) { return t.indexOf(q) !== -1; })) return false;
      if (prefix && h.n.toLowerCase().indexOf(prefix) !== 0) return false;
      if (f.platform !== 'all' && h.pl !== f.platform) return false;
      if (f.categories.length > 0 && f.categories.indexOf(h.c) === -1) return false;
      // Tags are AND-ed: picking two narrows the list, which is what a buyer
      // hunting a specific shape of name expects.
      if (f.tags.length > 0 && !f.tags.every(function (t) { return h.tags.indexOf(t) !== -1; })) return false;
      if (f.rarity !== 'all' && h.r !== f.rarity) return false;
      if (f.lengths.length > 0 && f.lengths.indexOf(lengthOption(h.n)) === -1) return false;
      if (f.composition !== 'all' && nameComposition(h.n) !== f.composition) return false;
      if (f.kind !== 'all' && h.t !== f.kind) return false;
      if (!matchesPattern(h.n, f.pattern)) return false;
      if (f.priceMin !== null && h.p < f.priceMin) return false;
      if (f.priceMax !== null && h.p > f.priceMax) return false;
      if (f.featured && !h.feat) return false;
      return true;
    });
    if (f.sort === 'price-asc') out.sort(function (a, b) { return a.p - b.p; });
    else if (f.sort === 'price-desc') out.sort(function (a, b) { return b.p - a.p; });
    else if (f.sort === 'length') out.sort(function (a, b) { return a.n.length - b.n.length || a.n.localeCompare(b.n); });
    else if (f.sort === 'rarity') out.sort(function (a, b) { return RANK[a.r] - RANK[b.r] || b.p - a.p; });
    else out.sort(function (a, b) { return (b.feat - a.feat) || b.p - a.p; });
    return out;
  }
  function facetCount(all, f, patch) { return filterHandles(all, Object.assign({}, f, patch)).length; }

  // Euros (already decimal) to the store's money format (€1.234,56), which is
  // what the checkout charges.
  function money(euros) {
    return fmt(Number(euros));
  }
  function fmt(v) {
    var parts = v.toFixed(2).split('.');
    return '\u20AC' + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
  }

  function cardHTML(h) {
    var sold = h.sold === 1;
    var plat = PLAT_SVG[h.pl] || '';
    var nameCls = 'ni-hcard__name';
    var priceExtra = '';
    var foot = sold
      ? '<span class="ni-hcard__add is-disabled">Sold</span>'
      : '<button type="button" class="ni-hcard__add" data-ni-add data-variant="' + h.vid + '" data-name="' + h.pfx + h.n + '" data-added-label="In cart ✓"><span data-ni-add-label>Add to cart →</span></button>';
    return '<article class="ni-card ni-hcard' + (sold ? ' is-sold' : '') + '">' +
      '<a href="' + h.url + '" class="ni-hcard__hit" aria-label="View ' + h.pfx + h.n + '"></a>' +
      '<div class="ni-card__inner ni-hcard__inner">' +
        '<div class="ni-hcard__top"><span class="ni-rarity ni-rarity--' + h.r + '">' + h.rl + '</span>' +
          '<span class="ni-hcard__plat"><span class="ni-plat" role="img" aria-label="' + h.pll + '">' + plat + '</span></span></div>' +
        '<div class="ni-hcard__mid"><span class="' + nameCls + '" style="--len: ' + (h.pfx.length + h.n.length) + '"><span class="ni-muted">' + h.pfx + '</span>' + h.n + '</span>' +
          '<p class="ni-hcard__stat">' + (sold ? 'Sold' : 'Available') + '</p>' +
          '<p class="ni-hcard__meta">' + h.n.length + ' letters · ' + h.cl + '</p></div>' +
        '<div class="ni-hcard__foot"><span class="ni-hcard__price"><span class="ni-hcard__amount">' + money(h.p) + '</span>' + priceExtra + '</span>' + foot + '</div>' +
      '</div></article>';
  }

  /* ---- state ---- */
  var DEFAULT = { query: '', platform: 'all', categories: [], tags: [], rarity: 'all', lengths: [], composition: 'all', kind: 'all', pattern: 'all', startsWith: '', priceMin: null, priceMax: null, featured: false, sort: 'featured' };
  var f = Object.assign({}, DEFAULT);
  var ALL = [], visible = PAGE_SIZE, results = [];

  var CATS = ['og','nature','culture','lifestyle','business','tech','fashion','sports','travel','food'];
  var RARS = ['legendary','rare','uncommon','common'];
  var PLATS = ['instagram','tiktok','telegram','snapchat','twitter','discord'];

  // The tag list is derived from the loaded catalogue, never hard-coded: a tag
  // added to the data appears here on the next load, and one that disappears
  // stops being offered.
  function buildTagFacet() {
    var box = el('.cm-tagbox');
    if (!box) return;
    var counts = {};
    ALL.forEach(function (h) {
      (h.tags || []).forEach(function (t) { counts[t] = (counts[t] || 0) + 1; });
    });
    var names = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a] || a.localeCompare(b); });
    box.innerHTML = names.map(function (t) {
      return '<button class="cm-opt cm-tag" data-tag="' + t + '">' + t +
        ' <span class="cm-tag-n" data-tag-count="' + t + '">' + counts[t] + '</span></button>';
    }).join('');
    els('.cm-tag').forEach(function (b) {
      b.addEventListener('click', function () {
        var t = b.getAttribute('data-tag');
        f.tags = f.tags.indexOf(t) === -1 ? f.tags.concat([t]) : f.tags.filter(function (x) { return x !== t; });
        visible = PAGE_SIZE; render();
      });
    });
  }

  function seedFromContext() {
    var col = root.getAttribute('data-collection') || '';
    if (RARS.indexOf(col) !== -1) f.rarity = col;
    else if (CATS.indexOf(col) !== -1) f.categories = [col];
    else if (PLATS.indexOf(col) !== -1) f.platform = col;
    else if (col === 'featured') f.featured = true;
    var p = new URLSearchParams(location.search);
    if (p.get('platform')) f.platform = p.get('platform');
    if (p.get('category')) f.categories = p.get('category').split(',').filter(Boolean);
    if (p.get('rarity')) f.rarity = p.get('rarity');
    if (p.get('tag')) f.tags = p.get('tag').split(',').filter(Boolean);
    if (p.get('q')) f.query = p.get('q');
  }

  var LABELS = {
    rarity: { legendary: 'Premium', rare: 'Word handles', uncommon: 'Short', common: 'Entry' },
    kind: { 'one-word': 'Word', acronym: 'Letters only', brandable: 'Mixed', niche: 'Compound' },
    comp: { letters: 'Letters only', digits: 'Digits only', mix: 'Letters + digits', special: 'With _ or .' },
    pat: { double: 'Double letters', repeating: 'Repeating (abab)', palindrome: 'Palindrome' },
    cat: { og: 'Short handles', nature: 'Nature', culture: 'Culture', lifestyle: 'Lifestyle', business: 'Business', tech: 'Tech', fashion: 'Fashion', sports: 'Sports', travel: 'Travel', food: 'Food' },
  };
  var CLOSE = '<svg viewBox="0 0 24 24" fill="none" width="12" height="12" style="opacity:.7"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  function el(sel) { return root.querySelector(sel); }
  function els(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function render() {
    results = filterHandles(ALL, f);
    // grid
    var grid = el('[data-cm-grid]');
    var empty = el('.cm-empty');
    if (results.length === 0) { grid.innerHTML = ''; empty.hidden = false; }
    else {
      empty.hidden = true;
      var slice = results.slice(0, visible);
      grid.innerHTML = slice.map(cardHTML).join('');
    }
    // count
    el('.cm-count').textContent = results.length + ' handle' + (results.length === 1 ? '' : 's');
    // show more
    var more = el('.cm-showmore');
    if (results.length > visible) { more.hidden = false; more.textContent = 'Show more · ' + (results.length - visible) + ' remaining'; }
    else more.hidden = true;
    // active states
    els('.cm-plat').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-plat') === f.platform); });
    els('.cm-len').forEach(function (b) {
      var l = b.getAttribute('data-len'); var active = f.lengths.indexOf(l) !== -1;
      var count = facetCount(ALL, f, { lengths: [l] });
      b.classList.toggle('is-active', active);
      b.disabled = !active && count === 0;
      b.querySelector('.cm-len-n').textContent = count;
    });
    els('[data-kind]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-kind') === f.kind); });
    els('[data-kind-count]').forEach(function (s) { s.textContent = facetCount(ALL, f, { kind: s.getAttribute('data-kind-count') }); });
    els('[data-comp]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-comp') === f.composition); });
    els('[data-comp-count]').forEach(function (s) { s.textContent = facetCount(ALL, f, { composition: s.getAttribute('data-comp-count') }); });
    els('[data-pat]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-pat') === f.pattern); });
    els('[data-rar]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-rar') === f.rarity); });
    els('[data-cat]').forEach(function (b) { b.classList.toggle('is-active', f.categories.indexOf(b.getAttribute('data-cat')) !== -1); });
    els('[data-tag]').forEach(function (b) { b.classList.toggle('is-active', f.tags.indexOf(b.getAttribute('data-tag')) !== -1); });
    els('[data-tag-count]').forEach(function (s2) {
      var t = s2.getAttribute('data-tag-count');
      s2.textContent = filterHandles(ALL, Object.assign({}, f, { tags: f.tags.indexOf(t) === -1 ? f.tags.concat([t]) : f.tags })).length;
    });
    els('.cm-price').forEach(function (b) {
      var mn = b.getAttribute('data-pmin'); var mx = b.getAttribute('data-pmax');
      mn = mn === '' ? null : Number(mn); mx = mx === '' ? null : Number(mx);
      b.classList.toggle('is-active', f.priceMin === mn && f.priceMax === mx);
    });
    renderTokens();
    syncUrl();
  }

  function renderTokens() {
    var t = [];
    if (f.rarity !== 'all') t.push({ label: LABELS.rarity[f.rarity], clear: function () { f.rarity = 'all'; } });
    f.lengths.forEach(function (l) { t.push({ label: l + ' chars', clear: function () { f.lengths = f.lengths.filter(function (x) { return x !== l; }); } }); });
    if (f.composition !== 'all') t.push({ label: LABELS.comp[f.composition], clear: function () { f.composition = 'all'; } });
    if (f.kind !== 'all') t.push({ label: LABELS.kind[f.kind], clear: function () { f.kind = 'all'; } });
    if (f.pattern !== 'all') t.push({ label: LABELS.pat[f.pattern], clear: function () { f.pattern = 'all'; } });
    if (f.startsWith.trim()) t.push({ label: 'Starts with “' + f.startsWith.trim() + '”', clear: function () { f.startsWith = ''; var i = el('.cm-starts'); if (i) i.value = ''; } });
    if (f.priceMin !== null || f.priceMax !== null) {
      var min = f.priceMin !== null ? '€' + f.priceMin : '€0';
      var max = f.priceMax !== null ? '€' + f.priceMax : '∞';
      t.push({ label: min + ' – ' + max, clear: function () { f.priceMin = null; f.priceMax = null; var a = el('.cm-pmin'), b = el('.cm-pmax'); if (a) a.value = ''; if (b) b.value = ''; } });
    }
    f.categories.forEach(function (c) { t.push({ label: LABELS.cat[c], clear: function () { f.categories = f.categories.filter(function (x) { return x !== c; }); } }); });
    f.tags.forEach(function (tg) { t.push({ label: '#' + tg, clear: function () { f.tags = f.tags.filter(function (x) { return x !== tg; }); } }); });

    var box = el('.cm-tokens'); box.innerHTML = '';
    t.forEach(function (tok) {
      var b = document.createElement('button');
      b.className = 'ni-cat__token' + (tok.danger ? ' is-danger' : '');
      b.innerHTML = tok.label + ' ' + CLOSE;
      b.addEventListener('click', function () { tok.clear(); visible = PAGE_SIZE; render(); });
      box.appendChild(b);
    });
    el('.cm-clear').hidden = t.length <= 1;
  }

  function syncUrl() {
    var p = new URLSearchParams();
    if (f.platform !== 'all') p.set('platform', f.platform);
    if (f.categories.length) p.set('category', f.categories.join(','));
    if (f.rarity !== 'all') p.set('rarity', f.rarity);
    if (f.tags.length) p.set('tag', f.tags.join(','));
    var base = location.pathname;
    history.replaceState(null, '', p.toString() ? base + '?' + p : base);
  }

  function change(patch) { Object.assign(f, patch); visible = PAGE_SIZE; render(); }

  function bind() {
    el('.cm-search').addEventListener('input', function (e) { change({ query: e.target.value }); });
    el('.cm-sort').addEventListener('change', function (e) { change({ sort: e.target.value }); });
    els('.cm-plat').forEach(function (b) { b.addEventListener('click', function () { change({ platform: b.getAttribute('data-plat') }); }); });
    els('.cm-len').forEach(function (b) { b.addEventListener('click', function () {
      var l = b.getAttribute('data-len'); var has = f.lengths.indexOf(l) !== -1;
      change({ lengths: has ? f.lengths.filter(function (x) { return x !== l; }) : f.lengths.concat([l]) });
    }); });
    els('[data-kind]').forEach(function (b) { b.addEventListener('click', function () { var v = b.getAttribute('data-kind'); change({ kind: f.kind === v ? 'all' : v }); }); });
    els('[data-comp]').forEach(function (b) { b.addEventListener('click', function () { var v = b.getAttribute('data-comp'); change({ composition: f.composition === v ? 'all' : v }); }); });
    els('[data-pat]').forEach(function (b) { b.addEventListener('click', function () { var v = b.getAttribute('data-pat'); change({ pattern: f.pattern === v ? 'all' : v }); }); });
    els('[data-rar]').forEach(function (b) { b.addEventListener('click', function () { var v = b.getAttribute('data-rar'); change({ rarity: f.rarity === v ? 'all' : v }); }); });
    els('[data-cat]').forEach(function (b) { b.addEventListener('click', function () {
      var v = b.getAttribute('data-cat'); var has = f.categories.indexOf(v) !== -1;
      change({ categories: has ? f.categories.filter(function (x) { return x !== v; }) : f.categories.concat([v]) });
    }); });
    els('.cm-price').forEach(function (b) { b.addEventListener('click', function () {
      var mn = b.getAttribute('data-pmin'); var mx = b.getAttribute('data-pmax');
      mn = mn === '' ? null : Number(mn); mx = mx === '' ? null : Number(mx);
      var active = f.priceMin === mn && f.priceMax === mx;
      change(active ? { priceMin: null, priceMax: null } : { priceMin: mn, priceMax: mx });
    }); });
    el('.cm-pmin').addEventListener('input', function (e) { change({ priceMin: e.target.value === '' ? null : Math.max(0, Number(e.target.value)) }); });
    el('.cm-pmax').addEventListener('input', function (e) { change({ priceMax: e.target.value === '' ? null : Math.max(0, Number(e.target.value)) }); });
    el('.cm-starts').addEventListener('input', function (e) { change({ startsWith: e.target.value }); });
    el('.cm-clear').addEventListener('click', function () { var q = f.query, s = f.sort; f = Object.assign({}, DEFAULT, { query: q, sort: s }); resetInputs(); visible = PAGE_SIZE; render(); });
    el('.cm-clear2').addEventListener('click', function () { f = Object.assign({}, DEFAULT); resetInputs(); visible = PAGE_SIZE; render(); });
    el('.cm-showmore').addEventListener('click', function () { visible += PAGE_SIZE; render(); });

    // more-filters dropdown
    var toggle = el('[data-more-toggle]'), menu = el('[data-more-menu]'), wrap = el('[data-more-wrap]');
    toggle.addEventListener('click', function () { menu.hidden = !menu.hidden; });
    document.addEventListener('mousedown', function (e) { if (menu && !menu.hidden && !wrap.contains(e.target)) menu.hidden = true; });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu) menu.hidden = true; });
  }
  function resetInputs() {
    el('.cm-search').value = f.query || '';
    el('.cm-sort').value = f.sort;
    el('.cm-starts').value = f.startsWith || '';
    el('.cm-pmin').value = f.priceMin == null ? '' : f.priceMin;
    el('.cm-pmax').value = f.priceMax == null ? '' : f.priceMax;
  }

  fetch(window.NI_CATALOG_URL, { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      ALL = data;
      seedFromContext();
      buildTagFacet();
      bind();
      resetInputs();
      render();
    })
    .catch(function (e) { el('[data-cm-grid]').innerHTML = '<p class="ni-cat__emptytitle">Could not load the catalogue.</p>'; });
})();
